module.exports = __webpack_public_path__ + "img/hand-draw-map-mxc-2.e56d7c0e.png";